import {
  DrawerNavigationProp,
  createDrawerNavigator,
} from "@react-navigation/drawer";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

type OrgHomeRegularDrawerParamList = {
  OrgStores: object;
  OrgUsers: object;
  OrgSpaces: {
    newlyCreatedSpaceId?: string;
  };
  WorkspaceFiles: object;
  WorkspaceRoutines: object;
  WorkspaceRoutineTemplates: object;
  WorkspaceTodos: object;
  WorkspaceSignals: object;
  WorkspaceProducts: object;
  WorkspaceAnalytics: object;
  WorkspaceDataTodo: object;
};

export type OrgHomeCompactStackParamList = OrgHomeRegularDrawerParamList & {
  OrgHomeMain: object;
};

export type OrgHomeRouteKey = keyof OrgHomeRegularDrawerParamList;

export type OrgHomeNavigationProp<T extends OrgHomeRouteKey> =
  CompositeNavigationProp<
    | NativeStackNavigationProp<OrgHomeCompactStackParamList, T>
    | DrawerNavigationProp<OrgHomeRegularDrawerParamList, T>,
    UserLoggedInNavigatorNavigationProp<"OrgHome">
  >;

type OrgHomeRouteProp<T extends OrgHomeRouteKey> = RouteProp<
  OrgHomeRegularDrawerParamList | OrgHomeCompactStackParamList,
  T
>;

export type OrgHomeScreenProps<T extends OrgHomeRouteKey> = {
  navigation: OrgHomeNavigationProp<T>;
  route: OrgHomeRouteProp<T>;
};

export const OrgHomeRegularDrawer =
  createDrawerNavigator<OrgHomeRegularDrawerParamList>();

export const OrgHomeCompactStack =
  createNativeStackNavigator<OrgHomeCompactStackParamList>();
